import api from './api';

const BASE = '/platform/reminders';

const unwrap = (r) => r?.data;

const firstError = (errors) => {
  const out = {};
  Object.entries(errors || {}).forEach(([field, messages]) => {
    out[field] = Array.isArray(messages) ? String(messages[0] || '') : String(messages || '');
  });
  return out;
};

export const mapLaravelError = (error) => {
  const payload = error?.response?.data || {};

  if (payload?.errors && typeof payload.errors === 'object') {
    return {
      message: payload.message || 'Validation failed.',
      fieldErrors: firstError(payload.errors),
      status: error?.response?.status || 422,
    };
  }

  return {
    message: payload?.message || error?.message || 'Request failed.',
    fieldErrors: {},
    status: error?.response?.status || 500,
  };
};

export const listReminders = async () => unwrap(await api.get(BASE));
export const updateReminderSettings = async (id, payload) =>
  unwrap(await api.put(`${BASE}/${id}`, payload));
export const previewReminders = async (id) => unwrap(await api.get(`${BASE}/${id}/preview`));
export const getReminderActivity = async (id, params = {}) =>
  unwrap(await api.get(`${BASE}/${id}/activity`, { params }));
export const runReminders = async (id) => unwrap(await api.post(`${BASE}/${id}/run`));

const platformRemindersApi = {
  listReminders,
  updateReminderSettings,
  previewReminders,
  getReminderActivity,
  runReminders,
  mapLaravelError,
};

export default platformRemindersApi;
